<template>
	<transition appear type="animation" :enter-active-class="transitionClass" @after-enter="complete">
		<div class="cover cat-animation"></div>
	</transition>
</template>

<script>
import soundFx from '@/mixins/sound-fx';

export default {
	name: 'Rays',
	mixins: [soundFx],
	props: ["state", "initialState"],
	computed: {
		transitionClass() {
			return this.initialState === "new" ? "spawn-new" : "";
		},
	},
	methods: {
		complete() {
			this.$emit("spawnComplete");
		},
	},
	mounted() {
		if (this.initialState === "new") {
			this.playRandomSound("new_spawn");
		}
	},
};
</script>

<style lang="scss" scoped>
	.spawn-new {
		z-index: -1;
	}
</style>



// WEBPACK FOOTER //
// src/components/cat/Rays.vue